import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Toolbar from '@material-ui/core/Toolbar'
import { closeMultiMessageDialog } from '../../actions/contacts/addOrEdit'
import { clickContactToEmail } from '../../actions/email'
import { clickContactToText } from '../../actions/sms'
import SMSPage from '../SMSPage'
import language from 'utils/vast-languagepack'
// import EmailPage from '../EmailPage'

const mapStateToProps = state => ({
  modalOpen: state.contacts.multiMessageDialogOpen,
  contact: state.contacts.contactClickedForMultiMessageDialog,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  closeMultiMessageDialog,
  clickContactToEmail,
  clickContactToText,
}, dispatch)

const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  flex: {
    flex: 1,
  },
  root: {
    flexGrow: 1,
    margin: theme.spacing.unit,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text,
  },
  enabledBackground: {
    cursor: 'pointer',
    background: theme.palette.primary.main,
  },
  disabledBackground: {
    background: '#BDBDBD',
  },
})

class MultiMessageDialog extends Component {
  state = {
    value: 0,
  }

  handleDialogClose = () => {
    this.props.closeMultiMessageDialog()
  }

  handleChange = (event, value) => {
    this.setState({ value })
  }

  render() {
    const { classes, contact } = this.props
    return (
      <Dialog
        open={this.props.modalOpen}
        onClose={this.handleDialogClose}
        fullScreen
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton color="inherit" onClick={this.handleDialogClose} aria-label="Close">
              <CloseIcon />
            </IconButton>
            <Tabs value={this.state.value} onChange={this.handleChange} centered>
              <Tab label={language.contacts.add.labels.emailLabel} />
              <Tab
                label={language.contacts.add.labels.smsLabel}
                disabled={!(contact && contact.phone)}
              />
            </Tabs>
          </Toolbar>
        </AppBar>
        <div className={classes.root}>
          {this.state.value === 0 && <div>{language.contacts.add.emailPage}</div>}
          {this.state.value === 1 && <SMSPage />}
        </div>
      </Dialog>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MultiMessageDialog))
